import React, { useContext } from 'react';
import KeyboardEventHandler from 'react-keyboard-event-handler';
import useDeepCompareEffect from 'use-deep-compare-effect';

import ShortkeyContext, { ShortKey } from './ShortkeyContext';

interface Props {
  handleKeys: string[];
  onKeyEvent: (key: any) => void;
  shortkeys: ShortKey[];
}

const ShortkeyListener: React.FC<Props> = ({
  handleKeys,
  onKeyEvent,
  shortkeys,
}) => {
  const { registerShortkey, unregisterShortkey } = useContext(ShortkeyContext);

  // need deep compare for shortkeys
  useDeepCompareEffect(() => {
    for (const key of shortkeys)
      registerShortkey(key.section, key.key, key.description);
    return () => {
      for (const key of shortkeys) {
        unregisterShortkey(key.section, key.key);
      }
    };
  }, [registerShortkey, shortkeys, unregisterShortkey]);

  return (
    <KeyboardEventHandler handleKeys={handleKeys} onKeyEvent={onKeyEvent} />
  );
};

export default ShortkeyListener;
